const BG_URL = "https://customer-assets.emergentagent.com/job_9013cffc-5815-4696-af30-6ef829e3ad5d/artifacts/1gmbyjsf_background.png";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_9013cffc-5815-4696-af30-6ef829e3ad5d/artifacts/390zcaea_logo.png";

export default function HeroSection() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-center items-center text-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_URL})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 px-6 max-w-4xl mx-auto opacity-0 animate-fade-in-up">
        <img src={LOGO_URL} alt="SitarMusic Logo" className="w-28 h-28 md:w-36 md:h-36 mx-auto mb-8 drop-shadow-2xl" />
        <h1 className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl lg:text-7xl font-medium text-[#fdfbf7] mb-6 leading-none tracking-tight">
          The Soul of the <span className="text-gold-gradient">Sitar</span>
        </h1>
        <p className="text-lg md:text-xl text-[#a3b1c6] max-w-2xl mx-auto leading-relaxed mb-10 font-light">
          Discover the timeless beauty of India's most iconic stringed instrument.
          From ancient ragas to modern fusion — your journey into sitar music begins here.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="hero-explore-btn"
            onClick={() => document.getElementById('artists')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-[#d4af37] text-[#0a1628] hover:bg-[#b49129] font-medium px-8 py-3.5 rounded-md transition-all duration-300 text-base"
          >
            Explore Artists
          </button>
          <button
            data-testid="hero-listen-btn"
            onClick={() => document.getElementById('media')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-transparent border border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a1628] px-8 py-3.5 rounded-md transition-all duration-300 text-base"
          >
            Listen Now
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 opacity-0 animate-fade-in-up animation-delay-500">
        <div className="w-6 h-10 border-2 border-[#d4af37]/40 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-[#d4af37]/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}
